// News placeholder images for items without custom images
import newsPlaceholder1 from './news-placeholder-1.svg';
import newsPlaceholder2 from './news-placeholder-2.svg';
import newsPlaceholder3 from './news-placeholder-3.svg';
import newsPlaceholder4 from './news-placeholder-4.svg';

export const DEFAULT_NEWS_IMAGES = [
  newsPlaceholder1,
  newsPlaceholder2,
  newsPlaceholder3,
  newsPlaceholder4,
];

export function getDefaultNewsImage(itemId: number): string {
  return DEFAULT_NEWS_IMAGES[Math.abs(itemId) % DEFAULT_NEWS_IMAGES.length];
}
